import { render, staticRenderFns } from "./adDetection.vue?vue&type=template&id=5b720902&scoped=true"
import script from "./adDetection.vue?vue&type=script&lang=js"
export * from "./adDetection.vue?vue&type=script&lang=js"
import style0 from "./adDetection.vue?vue&type=style&index=0&id=5b720902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b720902",
  null
  
)

export default component.exports